import script from "./ReviewDetailModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewDetailModal.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewDetailModal.vue?vue&type=style&index=0&id=7eefc08d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eefc08d"]])

export default __exports__